import React, { useEffect, useRef, useState } from "react";
import downloadPurpleIcon from "@assets/icon/download-purple-new.svg";
import productOverviewBackgroundConst from "@assets/images/product-overview-background.png";

import tickPurpleIcon from "@assets/icon/tick-purple.svg";
import downloadGreenIcon from "@assets/icon/evergreen-download.svg";
import tickGreenIcon from "@assets/icon/evergreen-tick.svg";
import { styled } from "@linaria/react";
import Button from "../Button";
import { get } from "lodash";
import { useAvivaSelector } from "@redux/hook";
import { CONTENT } from "@static/content";
import Text from "@components/Text";
import { SHIELD_STARTER } from "@static/staticConstents";
import { PLANS_NAME } from "@static/config";
import { SCREEN_SIZE } from "@static/screen-size";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { themeDefault } from "src/theme-revamp";
import dompurify from 'dompurify'
import { css } from "@linaria/core";

const ProductBrochureText = styled.p<{ primaryColor?: string }>`
  color: ${(props) => props.primaryColor || "#883E89"};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-decoration: underline;
  letter-spacing: 0.56px;
  margin-top: 6px;
`;

const ProductOverviewBackgroundImage = styled.img`
  /* flex-shrink: 0;
  object-fit: cover; */
  border-bottom-right-radius: 16px;
  margin-bottom: -8px;
  max-height: 500px;

  @media (max-width: ${SCREEN_SIZE.mobileSteper - 1}px) {
    width: 100%;
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 50%;
    margin-bottom: 0;
  }
`;

const evergreenImg = css`
  border-bottom-right-radius: 16px;
  /* margin-bottom: -8px; */
  max-height: 450px;

  @media (max-width: ${SCREEN_SIZE.mobileSteper - 1}px) {
    width: 100%;
    border-bottom-right-radius: 16px;
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 37%;
    margin-top: unset;
    margin-bottom: 0;
  }
`;

const ProductOverviewContent = styled.div`
  &[data-product="EVER_GREEN"] {
    #prdt-disclaimer,
    #prdt-featurelist {
      width: 100%;
      max-width: 461px;
    }
  }
  flex: 1;
  padding: 24px 52px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    padding: 24px 0 24px 102px;
  }
`;

const ProductBrochure = styled.a`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const ActionsContainer = styled.div`
  display: flex;
  column-gap: 30px;
  align-items: center;
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    column-gap: 46px;
  }
`;

const FeatureList = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  max-width: 354px;
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    max-width: 100%;
  }
`;

const ProductDescription = styled.p`
  color: #434343;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
`;

const ProductHeading = styled.h2`
  color: #434343;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
`;

const ProductOverviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  /* column-gap: 16px; */
  position: relative;
  overflow: hidden;
`;

const FeatureText = styled.p`
  color: #434343;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
`;

const FeatureItem = styled.li`
  display: flex;
  column-gap: 8px;
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  object-fit: contain;
  box-sizing: border-box;
  /* img {
    width: 100%;
    height: 100%;
  } */
`;

const HoverContent = styled.div``;

const HoverHeading = styled.h1`
  color: #ffffff;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.4;
`;

const HoverHeader = styled.div<{ primaryColor?: string }>`
  background-color: ${(props) => props.primaryColor || "#883e89"};
  padding: 16px 24px 13px 52px;
  border-radius: 16px 16px 0 0;
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    padding: 16px 102px 13px 102px;
  }
`;

const HoverBox = styled.div<HoverBoxProps>`
  background-color: #ffffff;
  box-sizing: border-box;
  display: inline-block;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 10px 62px;
  border-radius: 16px;
  position: relative;
  &:after {
    content: "";
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background-color: ${(props) => props.primaryColor || "#883e89"};
    position: absolute;
    top: -8px;
    left: ${(props) =>
      props.leftPosition ? props.leftPosition + "px" : "282px"};
    transform: matrix(0.71, -0.72, 0.7, 0.71, 0, 0);
  }
  width: 100%;
  max-width: 768px;
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    max-width: 1200px;
  }
`;

const HoverContainer = styled.div`
  padding-top: 11px;
  position: absolute;
  top: calc(100% - 20px);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 768px;
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    left: 0;
    right: 0;
    width: auto;
  }
`;

interface HoverBoxProps {
  leftPosition?: number;
  primaryColor?: string;
}

const ImageWrap = styled.div`
  &[data-product="EVER_GREEN"] {
    border-bottom-right-radius: 16px;
    padding-left: 15px;
    overflow: hidden;
  }

  /* flex: 1;
    position: relative; */
  /* @media (min-width: ${SCREEN_SIZE.mobileSteper}px) { 
      display: flex;
      flex: 0;
    } */
`;

const disclaimerCss = css`
  @media (max-width: ${SCREEN_SIZE.mobileSteper - 1}px) {
    max-width: 370px;
  }
`;

interface IProductOverviewProps {
  primaryColor: string | undefined;
}

export const ProductOverview = ({ primaryColor }: IProductOverviewProps) => {
  const currentPolicyFlow = useAvivaSelector(
    (state) => state.loading.CurrentPolicyFlow.policy
  );
  const content = CONTENT[currentPolicyFlow];
  const brouchureUrl = get(content, "brouchureUrl", "");
  const featureContentList = get(content, "features", []);
  const avivaBrochureUrl = get(window, brouchureUrl, "");
  const avivaFindOutMore = get(content, "findOutMoreUrl", "");
  const productOverviewBackground = get(content, "backgroundUrl", "");
  const productOverviewRef = useRef<HTMLDivElement>(null);
  const [arrowLeftPosition, setArrowLeftPositon] = useState<number>(282);
  const additionalArrowLeftSpace = 50;
  const heading = content.heading;
  const title = useAvivaSelector((state) => {
    if (heading.startsWith("dynamicPath")) {
      let keys = heading.split(":")[1]?.split(".") || [];
      let store: any = state;
      for (let x of keys) {
        if (store[x]) {
          store = store[x];
        }
      }
      return `${store}?`;
    }
    return "";
  });

  const icons = { download: "", tick: "" };
  if (currentPolicyFlow === PLANS_NAME.EVER_GREEN) {
    icons.download = downloadGreenIcon;
    icons.tick = tickGreenIcon;
  }

  useEffect(() => {
    if (productOverviewRef) {
      setArrowLeftPositon(
        productOverviewRef?.current?.parentElement?.offsetLeft
          ? productOverviewRef?.current?.parentElement?.offsetLeft +
              additionalArrowLeftSpace
          : 282
      );
    }
  }, [productOverviewRef]);

  return (
    <HoverContainer ref={productOverviewRef}>
      <HoverBox primaryColor={primaryColor} leftPosition={arrowLeftPosition}>
        <HoverHeader primaryColor={primaryColor}>
          <HoverHeading>Product Overview</HoverHeading>
        </HoverHeader>
        <HoverContent>
          <ProductOverviewContainer>
            <ProductOverviewContent data-product={currentPolicyFlow}>
              <ProductHeading>
                {content && `What is ${title || content.heading}`}
              </ProductHeading>
              <ProductDescription>
                {content && content.description}
              </ProductDescription>
              <FeatureList id="prdt-featurelist">
                {featureContentList.map((content) => {
                  return (
                    <FeatureItem>
                      <IconContainer>
                        <img
                          src={icons.tick || tickPurpleIcon}
                          alt="feature-icon"
                        />
                      </IconContainer>
                      <FeatureText
                        dangerouslySetInnerHTML={{ __html: dompurify.sanitize(content) }}
                      ></FeatureText>
                    </FeatureItem>
                  );
                })}
              </FeatureList>
              {content && content.disclaimer && (
                <Text
                  id="prdt-disclaimer"
                  className={disclaimerCss}
                  fontSize={12}
                  fontWeight={500}
                  color={"#8A8988"}
                >
                  {content.disclaimer}
                </Text>
              )}
              <ActionsContainer>
                <Button
                  theme={
                    currentPolicyFlow === PLANS_NAME.EVER_GREEN
                      ? EverGreenStyle
                      : themeDefault
                  }
                  fontSize="14px"
                  onClick={() => {
                    window.open(
                      avivaFindOutMore,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                  variant="secondary"
                  width="180px"
                  label="Find out more"
                  padding="15px 30px"
                />
                <ProductBrochure
                  onClick={() => {
                    window.open(
                      avivaBrochureUrl,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  <img
                    src={icons.download || downloadPurpleIcon}
                    alt="Product Brochure"
                  />
                  <ProductBrochureText primaryColor={primaryColor}>
                    Product Brochure
                  </ProductBrochureText>
                </ProductBrochure>
              </ActionsContainer>
            </ProductOverviewContent>
            <ImageWrap data-product={currentPolicyFlow}>
              <ProductOverviewBackgroundImage
                // width={undefined}
                // height={content.bgHeight}
                className={
                  currentPolicyFlow === PLANS_NAME.EVER_GREEN
                    ? evergreenImg
                    : ""
                }
                src={productOverviewBackground}
                alt="product-overview-background"
              />
            </ImageWrap>
          </ProductOverviewContainer>
        </HoverContent>
      </HoverBox>
    </HoverContainer>
  );
};
